import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchDolls = async () => {
  const { data } = await api.get("/dolls");
  return data;
};

export const fetchDoll = async (id) => {
  const { data } = await api.get(`/dolls/${id}`);
  return data;
};

export const updateDoll = async (id, payload) => {
  const { data } = await api.put(`/dolls/${id}`, payload);
  return data;
};

export const uploadDollImage = async (id, file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post(`/dolls/${id}/upload-image`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

// ---------- Photos ----------
export const fetchPhotos = async (category) => {
  const params = category && category !== "All" ? { category } : {};
  const { data } = await api.get("/photos", { params });
  return data;
};

export const fetchPhotoCategories = async () => {
  const { data } = await api.get("/photos/categories");
  return data.categories || [];
};

export const createPhoto = async ({ file, title, caption, category }) => {
  const form = new FormData();
  form.append("file", file);
  if (title) form.append("title", title);
  if (caption) form.append("caption", caption);
  form.append("category", category || "General");
  const { data } = await api.post("/photos", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const updatePhoto = async (id, patch) => {
  const { data } = await api.patch(`/photos/${id}`, patch);
  return data;
};

export const deletePhoto = async (id) => {
  const { data } = await api.delete(`/photos/${id}`);
  return data;
};

// Convert backend-relative image_url to full URL when needed
export const resolveImage = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};
